export enum InspectionTypeEnum {
  InspectionDesign = `תכנון המערכת`,
  InspectionInstallation = `התקנת המערכת`,
  InspectionDesignAndInstallation = `תכנון והתקנת המערכת`,
  InspectionWaterNetworkCharacterization = `בדיקת אופיין רשת מים`,
  InspectionGasExtinguishingSystem = `בדיקת מערכת כיבוי באמצעות גז`,
  InspectionFireTaps = `בדיקת התקנת ברזי שריפה`,
  InspectionFireExtinguishers = `בדיקת התקנת גלגילונים`,
  InspectionAerosolShutdown = `בדיקת כיבוי באמצעות ארוסול`,
  InspectionFireAlarmSystem = `בדיקת התקנת מערכת גילוי אש`,
  InspectionAirConditioningAndVentilationSystems = `מערכות בטיחות אש בבנינים ת"י 1001 חלק 1.1`,
  InspectionVentilationSystemAndFireProtection = `מערכות בטיחות אש בבניינים ת"י 1001 חלק 6`,
  InspectionPressureSystemInStairwellsCompatibilityCheck = `מערכות בטיחות אש בבנינים ת"י 1001 חלק 2.2`,
  InspectionIntegration = `בדיקת אינטגרציה לפי מכ"ר 536`
}

type LowercaseFirst<S extends string> = S extends `${infer F}${infer R}`
  ? `${Lowercase<F>}${R}`
  : S;

type EnumKeys = Exclude<
  keyof typeof InspectionTypeEnum,
  'InspectionDesignAndInstallation'
>;

export type InspectionProperty = LowercaseFirst<EnumKeys>;

export const InspectionTypes: InspectionProperty[] = [
  'inspectionDesign',
  'inspectionInstallation',
  'inspectionWaterNetworkCharacterization',
  'inspectionGasExtinguishingSystem',
  'inspectionFireTaps',
  'inspectionFireExtinguishers',
  'inspectionAerosolShutdown',
  'inspectionFireAlarmSystem',
  'inspectionAirConditioningAndVentilationSystems',
  'inspectionVentilationSystemAndFireProtection',
  'inspectionPressureSystemInStairwellsCompatibilityCheck',
  'inspectionIntegration'
];

export const InspectionStandardDescriptionMap: Record<
  InspectionProperty | 'inspectionDesignAndInstallation',
  string
> = {
  inspectionDesign: `מערכת לכיבוי אש באמצעות מתזים: בדיקת מערכת מתזים והתאמתה לדרישות התקן הישראלי ת"י 1596- מהדורה יולי 2019 (NFPA-13)`,
  inspectionInstallation: `מערכת לכיבוי אש באמצעות מתזים: בדיקת מערכת מתזים והתאמתה לדרישות התקן הישראלי ת"י 1596- מהדורה יולי 2019 (NFPA-13)`,
  inspectionDesignAndInstallation: `מערכת לכיבוי אש באמצעות מתזים: בדיקת מערכת מתזים והתאמתה לדרישות התקן הישראלי ת"י 1596- מהדורה יולי 2019 (NFPA-13)`,
  inspectionWaterNetworkCharacterization: `בדיקת אופין רשת מים: בדיקת ספיקת רשת מים עירונית בהתאם לדרישות ת"י 1596 ו-NFPA-13 , ובהתאם להוראות נציב 52`,
  inspectionGasExtinguishingSystem: `מערכת אוטומטית לכיבוי אש באמצעות גז FM-200: התאמת המערכת לדרישות התקן הישראלי ת"י 1597 מהדורה (NFPA-2001)`,
  inspectionFireTaps: `מתקני תברואה – בדיקת כיבוי אש – ברזי שריפה: התאמה לסעיפים : של התקן הישראלי ת"י 1205 חלק 1 וחלק 6 – התקנת מתקני תברואה ובדיקתם : שיטות בדיקה, מאפריל 2014`,
  inspectionFireExtinguishers: `גלגילונים לכיבוי אש: התאמת המערכת לדרישות התקן הישראלי ת"י 2206 חלק 2 -גלגלון לכיבוי אש : דרישות תכן, התקנה ותחזוקה דצמבר 2009 . גיליון תיקון מספר 1 מדצמבר 2012`,
  inspectionAerosolShutdown: `מערכת אוטומטית לכיבוי בלוחות חשמל באמצעות אירוסול: התאמת המערכת לדרישות התקן הישראלי ת"י 5210 מהדורה 2005, גיליון תיקון 2008`,
  inspectionFireAlarmSystem: `מערכת אוטומטית לגילוי אש: התאמת המערכת לדרישות התקן הישראלי ת"י 1220 חלק 3 "הוראות התקנה ודרישות" - מהדורה 2014`,
  inspectionAirConditioningAndVentilationSystems: `בדיקת התאמה למערכות מיזוג אוויר ואוורור: בדיקת תיכנון, תוכניות והתאמת התקנת מערכת מיזוג אוויר ואוורור לנדרש תחת ת"י 1001 חלק 1.1 - "בטיחות אש בבניינים ( מערכות מיזוג אוויר ואוורור" מהדורת יולי 2017 בלבד)`,
  inspectionVentilationSystemAndFireProtection: `מערכת אוורור והגנה מפני אש במערכות בישול מסחריות: בדיקת והתאמת התקנת מערכת נידוף בישול מסחרי תחת ת"י 1001 חלק- 6 "בטיחות אש בבניינים (אוורור והגנה מפני אש במערכות בישול מסחריות" מהדורת נובמבר 2018 בלבד`,
  inspectionPressureSystemInStairwellsCompatibilityCheck: `בדיקת התאמה למערכת על לחץ בחדרי מדרגות: בדיקת תיכנון, תוכניות והתאמת מערכת על לחץ בפרוזדור מילוט מוגן מעל 50 מטר לפי ת"י 1001 חלק 2.2 - "בטיחות אש בבניינים: מערכות בקרת עשן בבניינים (למעט בנייני מגורים שגובהם עד 13 מ') קניונים, אטריומים וחללים גדולים דומים" מהדורת נובמבר 2018`,
  inspectionIntegration: `בדיקת משטר הפעלות, מערכת בטיחות אש – אינטגרציה: התאמת המערכת לדרישות התקן הישראלי ת"י 1220 חלק 3 – מהדורה 2014 והוראות הנציב 536 עדכון 01/2023`
};
